import React, { Component } from 'react';
import classnames from 'classnames';
import { getEmptyImage } from 'react-dnd-html5-backend'
import { ItemTypes, PanelTypes, ModuleTypes } from '../../constants/sidebar/DragAndDropTypes';
import { DragSource, DropTarget } from 'react-dnd'
import { connect } from 'react-redux'
import { moveInModule, moveOutModule } from '../../actions/sidebar';
import { showEditSidebarModulePopup } from '../../actions/popup';

@connect(state => ({}),
dispatch => ({
    handleMoveInModule: (targetName, index, module) => {
        dispatch(moveInModule(targetName, index, module))
    },
    handleMoveOutModule: (panelName, moduleId) => {
        dispatch(moveOutModule(panelName, moduleId))
    },
    handleEditModule: (module) => {
        dispatch(showEditSidebarModulePopup(module))
    }
}))
@DragSource(ItemTypes.MODULE, {
    beginDrag(props) {
        return {
            from : props.panelIndex,
            module: props.module,
            index: props.index,
            moveFromPanel: props.moveOut,
            draggingId : props.module.moduleId,
        }
    },
    endDrag(props){

    },
    isDragging(props, monitor) {

        if(props.module.moduleId === monitor.getItem().draggingId)
            return true;

        return props.module.moduleId === monitor.getItem().module.moduleId;
    }
}, (connect, monitor) => {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    }
})
@DropTarget(ItemTypes.MODULE, {
    drop(props, monitor, component) {
        let draggingItem = monitor.getItem();
        const hoverIndex = props.index;

        props.moveIn(draggingItem, hoverIndex, draggingItem.from);
    },
    hover(props, monitor, component) {
        if(monitor.isOver({ shallow: true })) {
            const draggingItem = monitor.getItem();
            const hoverIndex = props.index;

            // 자기 자신의 위에 있으면 hover 처리 하지 않음
            if (draggingItem.module.moduleId === props.module.moduleId) {
                return;
            }
            props.moveIn(draggingItem, hoverIndex, draggingItem.from);
        }
    }
}, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
}))
class SideBarModule extends Component {

    constructor(props){
        super(props);

        this.state = {
            open_layer : false,
        };

        this.toggleLayer = this.toggleLayer.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.displayModuleEditButton = this.displayModuleEditButton.bind(this);
    }

    componentDidMount() {
        const { connectDragPreview } = this.props;
        connectDragPreview(getEmptyImage(), {
            captureDraggingState: true
        })
    }

    toggleLayer() {
        this.setState({
            open_layer : !this.state.open_layer
        })

    }

    handleRemove(module) {

        const { handleMoveInModule, handleMoveOutModule, panelIndex } = this.props;
        if(module.type === ModuleTypes.PLUGIN){
            handleMoveOutModule(panelIndex, module.moduleId);
        }else if(module.type === ModuleTypes.AD){
            alert('사이드바 광고는 수익센터에서 해제해주세요');
        }else{
            handleMoveOutModule(panelIndex, module.moduleId);
            handleMoveInModule(PanelTypes.BASIC, 0, module);
        }

    }

    render() {

        const { module } = this.props;
        const { connectDropTarget, connectDragSource, isDragging} = this.props;
        const { moduleCount } = this.props;

        return connectDropTarget(
            <div className="bundle_item">
                <div className={classnames({'insert_item': isDragging|| (module.moduleId > moduleCount)})}>
                    <div className="item_order" id={module.moduleId}>
                        <div className="basic_item">
                            { connectDragSource(<div className="wrap_drag">
                                <span className="ico_blog ico_drag" />
                            </div>)}
                            <span className="txt_name">
                                { module.type===ModuleTypes.PLUGIN ? <span className="txt_plugin">[플러그인] </span>:''}
                                { module.type===ModuleTypes.AD ? <span className="txt_plugin">[광고] </span>:''}
                                {module.title}
                            </span>
                            { this.displayModuleEditButton(module) }

                            <label className="lab_btn lab_del">
                                <span className="wrap_icon"><span className="ico_blog">삭제</span></span>
                                <input type="button" className="btn_g" value="삭제" onClick={(e) => this.handleRemove(module)}/>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    displayModuleEditButton(module) {

        const { handleEditModule } = this.props;

        if (module.editable) {
          return (
            <div className="info_btn">
              <button className="btn_post" onClick={(e) => handleEditModule(module)}>편집</button>
            </div>
          )
        }
    }
}

export default SideBarModule;
